import React from "react";
import DefaultLayout from "../layouts/DefaultLayout";
import BlogPostsFilter from "../sections/BlogPosts/BlogPostsFilter";
import BlogPostsList from "../sections/BlogPosts/BlogPostsList";
import Pagination from "../components/Pagination";
import Newsletter from "../components/Newsletter";
import DefaultHelmet from "../seo/DefaultHelmet";
import beaconWidgetIds from "../settings/beacon-widget-ids";
import useBeaconWidget from "../hooks/useBeaconWidget";
import useSchemaSettings from "../seo/schema/useSchemaSettings";
import { buildBlogCollectionSchema } from "../seo/schema";

const BlogPosts = ({ pageContext }) => {
	const {
		categories,
		posts,
		currentPage,
		pagesCount,
		categoryOriginPath,
		currentCategorySlug,
		pageTitle,
		pageMetaData,
		pageHeader,
	} = pageContext;

	const isBaseBlogPage = !currentCategorySlug && categoryOriginPath === "/blog";
	const baseTitle = isBaseBlogPage
		? pageMetaData?.title || pageTitle
		: pageTitle;
	const baseDescription = isBaseBlogPage
		? pageMetaData?.description || "UTD Blog"
		: "UTD Blog, category: " + pageTitle;
	const helmetTitle = currentPage > 1
		? baseTitle + " | Blog page " + currentPage
		: baseTitle;
	const pageDescription = currentPage > 1
		? baseDescription + ", page: " + currentPage
		: baseDescription;
	const shouldBuildBlogSchema = categoryOriginPath === "/blog" && currentPage === 1;
	const schemaContext = useSchemaSettings();
	const structuredData = shouldBuildBlogSchema
		? buildBlogCollectionSchema({
			schemaContext,
			title: helmetTitle,
			description: pageDescription,
			currentPage,
			categoryOriginPath,
		})
		: null;

	useBeaconWidget(beaconWidgetIds.GENERAL);

	return (
		<DefaultLayout isHeaderWithBlackText={true}>
			<DefaultHelmet
				title={helmetTitle}
				description={pageDescription}
				keywords={"UTD, UTD Blog, eCommerce, eCommerce news"}
				meta={currentPage > 1 ? [{ name: "robots", content: "noindex, follow" }] : []}
				structuredData={structuredData}
			/>

			<BlogPostsFilter
				title={pageTitle}
				categories={categories}
				currentCategorySlug={currentCategorySlug}
				pageHeader={pageHeader}
			/>

			<BlogPostsList
				posts={posts}
			/>

			<Pagination
				pagesCount={pagesCount}
				currentPage={currentPage}
				originalPath={categoryOriginPath}
				containerClasses={"container--medium"}
			/>

			<div className="blog-posts-newsletter">
				<Newsletter />
			</div>
		</DefaultLayout>
	);
};

export default BlogPosts;
